import ChangelogDocsPage from './pages/ChangelogDocsPage'
import WebpageDocsPage from './pages/WebpageDocsPage'
import messages from './i18n'

export default {
  key: 'common',
  messages: messages,
  routes: [
    {
      path: '/balaena-docs/changelog',
      component: ChangelogDocsPage
    },
    {
      path: '/balaena-docs/webpages',
      component: WebpageDocsPage
    }
  ]
}
